import React, { useState } from 'react';

function Accounting() {
  const [regime, setRegime] = useState('УСН');
  const [income, setIncome] = useState('');
  const [expense, setExpense] = useState('');
  const [result, setResult] = useState(null);

  const calculateTax = () => {
    const inc = parseFloat(income) || 0;
    const exp = parseFloat(expense) || 0;

    let tax = 0;
    let details = '';

    if (regime === 'УСН') {
      // УСН Доходы: 6%, УСН Доходы-Расходы: 15%
      const tax6 = inc * 0.06;
      const profit = inc - exp;
      const tax15 = profit > 0 ? profit * 0.15 : 0;
      tax = Math.min(tax6, tax15);
      details = `УСН 6%: ${tax6.toLocaleString()} ₽ | УСН 15% (доходы−расходы): ${tax15.toLocaleString()} ₽\nВыбран минимальный налог: ${tax.toLocaleString()} ₽`;
    } else if (regime === 'ОСНО') {
      const profit = inc - exp;
      const profitTax = profit > 0 ? profit * 0.25 : 0;
      const vat = inc * 0.22;
      tax = profitTax + vat;
      details = `Налог на прибыль 25%: ${profitTax.toLocaleString()} ₽\nНДС 22%: ${vat.toLocaleString()} ₽\nИтого: ${tax.toLocaleString()} ₽`;
    } else if (regime === 'ПСН') {
      tax = 30000; // Фиксированная стоимость патента
      details = `Патент (фиксированный): 30 000 ₽ в год`;
    }

    setResult({ tax, details, income: inc, expense: exp });
  };

  const generateDeclaration = () => {
    if (!result) return;
    const today = new Date().toLocaleDateString('ru-RU');
    const decl = `НАЛОГОВАЯ ДЕКЛАРАЦИЯ ПО ${regime}
Дата формирования: ${today}
Налогоплательщик: ИП Иванов И.И.

Доходы за период: ${result.income.toLocaleString()} ₽
Расходы за период: ${result.expense.toLocaleString()} ₽
Налог к уплате: ${result.tax.toLocaleString()} ₽

Расчёт:
${result.details}

Подпись налогоплательщика: _______________
Дата: ${today}
`;
    alert(decl);
  };

  return (
    <div>
      <h2>📊 Tax Calculator & Declaration</h2>
      <p style={{ color: '#94A3B8', fontSize: 13, marginTop: 4, marginBottom: 16 }}>
        Calculate taxes and auto-fill declaration based on your tax regime
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, maxWidth: 400, marginBottom: 20 }}>
        <label style={{ color: '#94A3B8', fontSize: 13 }}>Tax Regime</label>
        <select value={regime} onChange={e => setRegime(e.target.value)} style={inputStyle}>
          <option>УСН</option>
          <option>ОСНО</option>
          <option>ПСН</option>
        </select>

        <label style={{ color: '#94A3B8', fontSize: 13 }}>Income (₽)</label>
        <input value={income} onChange={e => setIncome(e.target.value)} placeholder="Например: 5000000" style={inputStyle} />

        <label style={{ color: '#94A3B8', fontSize: 13 }}>Expenses (₽)</label>
        <input value={expense} onChange={e => setExpense(e.target.value)} placeholder="Например: 2000000" style={inputStyle} />

        <button onClick={calculateTax} style={{ padding: 12, background: '#6366F1', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600, marginTop: 8 }}>
          Calculate Tax
        </button>
      </div>

      {result && (
        <div style={{ padding: 16, background: '#1E293B', borderRadius: 12, border: '1px solid #334155', marginBottom: 16 }}>
          <h3 style={{ marginBottom: 10, color: '#10B981' }}>Tax to Pay: {result.tax.toLocaleString()} ₽</h3>
          <pre style={{ color: '#94A3B8', fontSize: 13, whiteSpace: 'pre-wrap', lineHeight: 1.6 }}>
            {result.details}
          </pre>
          <button onClick={generateDeclaration} style={{ padding: '10px 20px', background: '#10B981', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600, marginTop: 12 }}>
            📄 Generate Declaration
          </button>
        </div>
      )}

      <div style={{ padding: 14, background: '#1E293B', borderRadius: 8, border: '1px solid #334155' }}>
        <h4 style={{ marginBottom: 6 }}>Tax Regime Info (2026)</h4>
        <ul style={{ color: '#94A3B8', fontSize: 13, paddingLeft: 20 }}>
          <li>УСН: 6% (доходы) или 15% (доходы−расходы). Порог — 20 млн ₽ для освобождения от НДС.</li>
          <li>ОСНО: налог на прибыль 25%, НДС 22%.</li>
          <li>ПСН: фиксированная стоимость патента (зависит от региона и вида деятельности).</li>
        </ul>
      </div>
    </div>
  );
}

const inputStyle = { padding: 10, background: '#0F172A', border: '1px solid #334155', borderRadius: 8, color: '#F8FAFC', fontSize: 14 };

export default Accounting;